// @ts-nocheck
/* SALIHA Product Page — vanilla JS
   Pattern variant: ricalca saliha-bundle-builder.js (option1/option2/option3)
   AJAX cart: /cart/add.js + cart:refresh / cart:open events
*/
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__salihaPpInit) return;
    root.__salihaPpInit = true;

    const productData = readProductData(root);
    if (!productData) {
      console.warn('[saliha-pp] no product data on root');
      return;
    }

    const state = {
      currentMediaIndex: 0,
      zoom: false,
      bundleId: root.dataset.defaultBundle || null,
      // optionValues keyed by Shopify option name (e.g. {Colore:'Sabbia', Taglia:'54'})
      optionValues: {},
      qty: 1,
      currentVariant: null,
    };

    // pre-fill with first available variant
    const initialVariant = productData.variants.find((v) => v.available) || productData.variants[0];
    if (initialVariant) {
      productData.options.forEach((optName, i) => {
        state.optionValues[optName] = initialVariant['option' + (i + 1)];
      });
      state.currentVariant = initialVariant;
    }

    initGallery(root, state);
    initVariantPicker(root, productData, state);
    initBundle(root, state);
    initQuantity(root, state);
    initCTA(root, productData, state);
    initBuyNow(root, productData, state);
    initStickyATC(root, productData, state);
    initWishlistShare(root, productData);
    initFBT(root, productData, state);
    initGiftForm(root, state);
    initSoldoutWaitlist(root, productData);
    initBonusScarcity(root);
    initUrgencyCountdown(root);

    // Bug #2 mitigation: if PDP is configured as giftbox but gift_form block is missing,
    // warn loudly so the misconfiguration is detected before the buyer is shipped a box
    // without the calligraphy note / wrap selection.
    if (root.dataset.giftboxRequiresForm === 'true' && !root.querySelector('[data-saliha-pp-giftform]')) {
      console.error('[saliha-pp] CRITICAL: gift box template requires gift_form block but it is missing. Properties Per/Da/Messaggio NOT collectable.');
    }

    // Initial sync
    syncVariant(root, productData, state);
  }

  // ──────────────────────────────────────────────────────────
  //   Read JSON product injected by Liquid
  // ──────────────────────────────────────────────────────────
  function readProductData(root) {
    const tag = root.querySelector('[data-saliha-pp-product-json]');
    if (!tag) return null;
    try {
      return JSON.parse(tag.textContent);
    } catch (e) {
      console.error('[saliha-pp] bad product JSON', e);
      return null;
    }
  }

  // ──────────────────────────────────────────────────────────
  //   GALLERY
  // ──────────────────────────────────────────────────────────
  function initGallery(root, state) {
    const stage = root.querySelector('[data-saliha-pp-stage]');
    if (!stage) return;
    const slides = Array.from(stage.querySelectorAll('[data-saliha-pp-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-saliha-pp-thumb]'));
    const counterCurrent = root.querySelector('[data-saliha-pp-counter-current]');
    const counterTotal = root.querySelector('[data-saliha-pp-counter-total]');
    const arrowPrev = root.querySelector('[data-saliha-pp-arrow="prev"]');
    const arrowNext = root.querySelector('[data-saliha-pp-arrow="next"]');

    if (counterTotal) counterTotal.textContent = String(slides.length).padStart(3, '0');

    function setActive(i) {
      const idx = (i + slides.length) % slides.length;
      state.currentMediaIndex = idx;
      slides.forEach((el, k) => el.classList.toggle('is-active', k === idx));
      thumbs.forEach((el, k) => el.classList.toggle('is-active', k === idx));
      if (counterCurrent) counterCurrent.textContent = String(idx + 1).padStart(3, '0');
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => setActive(i)));
    if (arrowPrev) arrowPrev.addEventListener('click', (e) => { e.stopPropagation(); setActive(state.currentMediaIndex - 1); });
    if (arrowNext) arrowNext.addEventListener('click', (e) => { e.stopPropagation(); setActive(state.currentMediaIndex + 1); });

    // Zoom toggle (desktop only)
    function toggleZoom(force) {
      if (window.matchMedia('(max-width: 768px)').matches) return;
      state.zoom = typeof force === 'boolean' ? force : !state.zoom;
      stage.dataset.zoom = state.zoom ? 'on' : 'off';
    }
    stage.addEventListener('click', () => toggleZoom());
    // Keyboard a11y: Enter/Space ingrandisce, Esc riduce (SC 2.1.1 / 2.1.2)
    stage.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggleZoom(); }
      else if (e.key === 'Escape' && state.zoom) { e.preventDefault(); toggleZoom(false); }
    });

    stage.addEventListener('mousemove', (e) => {
      if (!state.zoom) return;
      const r = stage.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      const active = stage.querySelector('.saliha-pp__stage-img.is-active');
      if (active) active.style.transformOrigin = `${x}% ${y}%`;
    });

    // Keyboard
    document.addEventListener('keydown', (e) => {
      if (!isGalleryFocused(root)) return;
      if (e.key === 'ArrowRight') setActive(state.currentMediaIndex + 1);
      if (e.key === 'ArrowLeft') setActive(state.currentMediaIndex - 1);
    });

    // Touch swipe (mobile)
    let touchStartX = null;
    stage.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (touchStartX == null) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) setActive(state.currentMediaIndex + (dx < 0 ? 1 : -1));
      touchStartX = null;
    });

    setActive(0);
    state.galleryAPI = { setActive };
  }

  function isGalleryFocused(root) {
    const r = root.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  // ──────────────────────────────────────────────────────────
  //   VARIANT PICKER (swatches + sizes + select fallback)
  // ──────────────────────────────────────────────────────────
  function initVariantPicker(root, product, state) {
    const swatchBtns = Array.from(root.querySelectorAll('[data-saliha-pp-swatch]'));
    const sizeBtns = Array.from(root.querySelectorAll('[data-saliha-pp-size]'));
    const selects = Array.from(root.querySelectorAll('[data-saliha-pp-option-select]'));

    swatchBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.dataset.disabled === 'true') return;
        const optName = btn.dataset.option;
        const val = btn.dataset.value;
        state.optionValues[optName] = val;
        syncVariant(root, product, state);
      });
    });
    sizeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const optName = btn.dataset.option;
        const val = btn.dataset.value;
        state.optionValues[optName] = val;
        syncVariant(root, product, state);
      });
    });
    selects.forEach((sel) => {
      sel.addEventListener('change', () => {
        const optName = sel.dataset.option;
        state.optionValues[optName] = sel.value;
        syncVariant(root, product, state);
      });
    });

    initRadiogroupKeyboard(root);
  }

  // WAI-ARIA radio pattern: roving tabindex + arrow/Home/End navigation with
  // selection-follows-focus. Layered on top of the click handlers above so the
  // existing variant-selection logic (syncVariant) remains the single source of
  // truth. stopPropagation keeps the gallery keydown (document-level, fires on
  // any ArrowLeft/Right while the section is visible) from also reacting.
  function initRadiogroupKeyboard(root) {
    const NAV = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
    Array.from(root.querySelectorAll('[role="radiogroup"]')).forEach((group) => {
      group.addEventListener('keydown', (e) => {
        if (NAV.indexOf(e.key) === -1) return;
        const radios = Array.from(group.querySelectorAll('[role="radio"]')).filter((r) => {
          return !r.disabled && r.getAttribute('aria-disabled') !== 'true' && r.dataset.disabled !== 'true';
        });
        if (!radios.length) return;
        e.preventDefault();
        e.stopPropagation();
        let idx = radios.indexOf(document.activeElement);
        if (idx === -1) idx = radios.findIndex((r) => r.getAttribute('aria-checked') === 'true');
        if (idx === -1) idx = 0;
        let next = idx;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % radios.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + radios.length) % radios.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = radios.length - 1;
        const target = radios[next];
        if (target) { target.click(); target.focus(); }
      });
    });
  }

  function findVariant(product, optionValues) {
    return product.variants.find((v) => {
      return product.options.every((optName, i) => {
        const want = optionValues[optName];
        return want === undefined || v['option' + (i + 1)] === want;
      });
    });
  }

  function syncVariant(root, product, state) {
    const prevId = state.currentVariant && state.currentVariant.id;
    const variant = findVariant(product, state.optionValues);
    state.currentVariant = variant || null;

    // Sync UI
    syncVariantUI(root, product, state);
    syncPrice(root, product, state);
    syncCTA(root, state);
    syncMediaForVariant(root, state);

    // Fire variant:changed if id actually changed — listeners (e.g. gift form
    // tracker) reset stale state per Bug #3 fix.
    const newId = state.currentVariant && state.currentVariant.id;
    if (prevId !== newId) {
      try {
        root.dispatchEvent(new CustomEvent('saliha:variant:changed', {
          bubbles: true,
          detail: { previousId: prevId, currentId: newId },
        }));
      } catch (_) {}
    }
  }

  // Guarantee exactly one tabbable radio in a roving-tabindex group, falling
  // back to the first enabled control when the selected one is unavailable.
  // Real `disabled` buttons drop out of the tab order even with tabindex=0, so
  // without this a color change that sells out the selected size would strand
  // the size group outside the tab sequence (WCAG 2.1.1 / 2.4.3).
  function ensureRovingTabStop(btns, isEnabled) {
    const enabled = btns.filter(isEnabled);
    if (enabled.length && !enabled.some((b) => b.tabIndex === 0)) {
      btns.forEach((b) => { b.tabIndex = -1; });
      enabled[0].tabIndex = 0;
    }
  }

  function syncVariantUI(root, product, state) {
    const swatchBtns = Array.from(root.querySelectorAll('[data-saliha-pp-swatch]'));
    swatchBtns.forEach((btn) => {
      const optName = btn.dataset.option;
      const val = btn.dataset.value;
      btn.classList.toggle('is-active', state.optionValues[optName] === val);
      btn.setAttribute('aria-checked', state.optionValues[optName] === val ? 'true' : 'false');
      btn.tabIndex = state.optionValues[optName] === val ? 0 : -1;

      // Disabled if no available variant matches this swatch given other selections
      const trial = { ...state.optionValues, [optName]: val };
      const match = findVariant(product, trial);
      btn.dataset.disabled = match && match.available ? 'false' : (match ? 'false' : 'true');
    });
    ensureRovingTabStop(swatchBtns, (b) => b.dataset.disabled !== 'true');

    const sizeBtns = Array.from(root.querySelectorAll('[data-saliha-pp-size]'));
    sizeBtns.forEach((btn) => {
      const optName = btn.dataset.option;
      const val = btn.dataset.value;
      btn.classList.toggle('is-active', state.optionValues[optName] === val);
      btn.setAttribute('aria-checked', state.optionValues[optName] === val ? 'true' : 'false');
      btn.tabIndex = state.optionValues[optName] === val ? 0 : -1;

      const trial = { ...state.optionValues, [optName]: val };
      const match = findVariant(product, trial);
      if (!match) {
        btn.disabled = true;
        btn.dataset.stock = 'out';
      } else {
        btn.disabled = !match.available;
        btn.dataset.stock = match.available
          ? (match.inventory_quantity != null && match.inventory_quantity <= 5 && match.inventory_quantity > 0 ? 'low' : 'in')
          : 'out';
      }
    });
    ensureRovingTabStop(sizeBtns, (b) => !b.disabled);

    // Display selected option labels
    Array.from(root.querySelectorAll('[data-saliha-pp-option-current]')).forEach((el) => {
      const optName = el.dataset.option;
      el.textContent = state.optionValues[optName] || '';
    });
  }

  function syncPrice(root, product, state) {
    const v = state.currentVariant;
    const priceEls = root.querySelectorAll('[data-saliha-pp-price]');
    const compareEl = root.querySelector('[data-saliha-pp-price-compare]');
    const discountEl = root.querySelector('[data-saliha-pp-price-discount]');
    const installmentsEl = root.querySelector('[data-saliha-pp-price-installments]');
    const stickyPriceEl = root.querySelector('[data-saliha-pp-sticky-price]');

    if (!v) return;

    priceEls.forEach((el) => { el.textContent = formatMoney(v.price); });
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(v.price);

    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (discountEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        const pct = Math.round((1 - v.price / v.compare_at_price) * 100);
        discountEl.textContent = '−' + pct + '%';
        discountEl.hidden = false;
      } else {
        discountEl.hidden = true;
      }
    }
    if (installmentsEl && installmentsEl.dataset.template) {
      installmentsEl.textContent = installmentsEl.dataset.template.replace('[amount]', formatMoney(Math.round(v.price / 3)));
    }
  }

  function syncCTA(root, state) {
    const cta = root.querySelector('[data-saliha-pp-add-to-cart]');
    const stickyCta = root.querySelector('[data-saliha-pp-sticky-cta]');
    const v = state.currentVariant;
    [cta, stickyCta].forEach((btn) => {
      if (!btn) return;
      if (!v) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        const lbl = btn.querySelector('[data-saliha-pp-cta-label]');
        if (lbl) lbl.textContent = btn.dataset.unavailableLabel || 'Combinazione non disponibile';
        return;
      }
      if (!v.available) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        const lbl = btn.querySelector('[data-saliha-pp-cta-label]');
        if (lbl) lbl.textContent = btn.dataset.soldoutLabel || 'Esaurito';
        return;
      }
      btn.disabled = false;
      btn.setAttribute('aria-disabled', 'false');
      const lbl = btn.querySelector('[data-saliha-pp-cta-label]');
      if (lbl) {
        const baseLabel = btn.dataset.defaultLabel || 'Aggiungi al carrello';
        lbl.textContent = (state.bundleQty && state.bundleQty > 1) ? 'Aggiungi ' + state.bundleQty + ' al carrello' : baseLabel;
      }
    });
  }

  function syncMediaForVariant(root, state) {
    const v = state.currentVariant;
    if (!v || !v.featured_media) return;
    // Find slide whose data-media-id matches
    const stage = root.querySelector('[data-saliha-pp-stage]');
    if (!stage) return;
    const target = stage.querySelector(`[data-saliha-pp-slide][data-media-id="${v.featured_media.id}"]`);
    if (!target) return;
    const slides = Array.from(stage.querySelectorAll('[data-saliha-pp-slide]'));
    const idx = slides.indexOf(target);
    if (idx >= 0 && state.galleryAPI) state.galleryAPI.setActive(idx);
  }

  // ──────────────────────────────────────────────────────────
  //   BUNDLE
  // ──────────────────────────────────────────────────────────
  function initBundle(root, state) {
    const opts = Array.from(root.querySelectorAll('[data-saliha-pp-bundle-opt]'));
    if (!opts.length) return;
    opts.forEach((btn) => {
      btn.addEventListener('click', () => {
        opts.forEach((b) => b.classList.toggle('is-active', b === btn));
        state.bundleId = btn.dataset.bundleId;
        state.bundleQty = parseInt(btn.dataset.bundleQty || '1', 10);
        syncCTA(root, state); // feedback: la CTA riflette la quantità del pacchetto
      });
    });
    const initial = opts.find((b) => b.classList.contains('is-active')) || opts[0];
    if (initial) {
      state.bundleId = initial.dataset.bundleId;
      state.bundleQty = parseInt(initial.dataset.bundleQty || '1', 10);
    }
  }

  // ──────────────────────────────────────────────────────────
  //   QUANTITY
  // ──────────────────────────────────────────────────────────
  function initQuantity(root, state) {
    const wrap = root.querySelector('[data-saliha-pp-qty]');
    if (!wrap) return;
    const input = wrap.querySelector('input');
    const dec = wrap.querySelector('[data-saliha-pp-qty-dec]');
    const inc = wrap.querySelector('[data-saliha-pp-qty-inc]');
    function set(v) {
      const n = Math.max(1, Math.min(99, parseInt(v, 10) || 1));
      state.qty = n;
      if (input) input.value = String(n);
    }
    if (dec) dec.addEventListener('click', () => set(state.qty - 1));
    if (inc) inc.addEventListener('click', () => set(state.qty + 1));
    if (input) input.addEventListener('change', () => set(input.value));
    set(1);
  }

  // ──────────────────────────────────────────────────────────
  //   CTA → AJAX add to cart
  // ──────────────────────────────────────────────────────────
  function initCTA(root, product, state) {
    // Solo il CTA principale: il bottone sticky delega con .click() a questo
    // (vedi initStickyATC) — nessuna logica ATC duplicata.
    const cta = root.querySelector('[data-saliha-pp-add-to-cart]');
    if (!cta) return;
    cta.addEventListener('click', (e) => {
      e.preventDefault();
      addToCart(root, product, state, cta, { buyNow: false });
    });
  }

  function initBuyNow(root, product, state) {
    const buyBtn = root.querySelector('[data-saliha-pp-buy-now]');
    if (!buyBtn) return;
    buyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      addToCart(root, product, state, buyBtn, { buyNow: true });
    });
  }

  async function addToCart(root, product, state, btn, opts) {
    opts = opts || {};
    const v = state.currentVariant;
    if (!v || !v.available) return;
    btn.disabled = true;
    btn.setAttribute('data-loading', 'true');

    // Resolve qty: bundle multiplier × user qty
    const baseQty = state.qty || 1;
    const bundleQty = state.bundleQty || 1;
    const totalQty = baseQty * bundleQty;

    const item = {
      id: v.id,
      quantity: totalQty,
      properties: {},
    };
    if (state.bundleId && bundleQty > 1) {
      item.properties['_bundle_tier'] = state.bundleId;
    }

    // Gift form properties — SEMPRE leggi i campi se gift_form block presente.
    // Il toggle <details> è solo UI di espansione: i dati semantici contano,
    // non lo stato visuale. Se l'utente compila e poi chiude per errore, NON perde.
    const giftForm = root.querySelector('[data-saliha-pp-giftform]');
    let giftCompleted = false;
    if (giftForm) {
      const giftTo = (giftForm.querySelector('[data-saliha-pp-gift-to]')?.value || '').trim();
      const giftFrom = (giftForm.querySelector('[data-saliha-pp-gift-from]')?.value || '').trim();
      const giftMsg = (giftForm.querySelector('[data-saliha-pp-gift-msg]')?.value || '').trim();
      const giftAnon = giftForm.querySelector('[data-saliha-pp-gift-anonymous]')?.checked || false;
      const wrapEl = giftForm.querySelector('[data-saliha-pp-gift-wrap]:checked');
      const giftWrap = wrapEl ? wrapEl.value : '';
      const giftDate = (giftForm.querySelector('[data-saliha-pp-gift-date]')?.value || '').trim();
      const giftInitials = (giftForm.querySelector('[data-saliha-pp-gift-initials]')?.value || '').trim().slice(0, 3).toUpperCase();
      if (giftTo) item.properties['Per'] = giftTo;
      if (giftFrom) item.properties['Da'] = giftFrom;
      if (giftMsg) item.properties['Messaggio biglietto'] = giftMsg;
      if (giftAnon) item.properties['Spedizione anonima'] = 'Sì · pacco senza scontrino, fattura via email';
      if (giftWrap && giftWrap !== 'standard') {
        item.properties['Confezione'] = giftWrap === 'velvet' ? 'Velvet premium · scatola velluto + nastro seta (+€8)' : giftWrap;
      }
      if (giftDate) item.properties['Data consegna desiderata'] = giftDate;
      if (giftInitials) item.properties['Iniziali ricamate nastro'] = giftInitials + ' (+€12)';
      giftCompleted = !!(giftTo || giftFrom || giftMsg || giftAnon || (giftWrap && giftWrap !== 'standard') || giftDate || giftInitials);
    }

    // Telemetry — distinguish gift purchase from self-buy in analytics.
    try {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'add_to_cart',
        purchase_type: giftCompleted ? 'gift' : 'self',
        product_id: product.id,
        variant_id: v.id,
        product_title: product.title,
        price: v.price,
        gift_anonymous_shipping: giftForm
          ? !!giftForm.querySelector('[data-saliha-pp-gift-anonymous]')?.checked
          : false,
      });
    } catch (_) {}

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || `Errore ${res.status}`);
      }

      const cartData = await res.clone().json().catch(() => ({}));

      if (opts.buyNow) {
        window.location.href = '/checkout';
        return;
      }

      showToast(root, product, v);

      // 1) Refresh cart fragments (Horizon cart-icon, sticky bar, shipping bar)
      const cartResp = await fetch('/cart.js').then(r => r.json()).catch(() => null);
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartResp || cartData,
          sourceId: 'saliha-pp',
          // itemCount: cart-icon.js legge detail.data.itemCount ?? 0 —
          // senza il valore reale azzererebbe la bubble (e sessionStorage).
          data: { source: 'saliha-pp', itemCount: cartResp ? cartResp.item_count : undefined }
        }
      }));
      // 2) Legacy event (saliha-shipping-bar listens to this)
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // 3) Open Horizon native cart drawer
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        try { drawer.open(); } catch (_) {}
      } else {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }
    } catch (e) {
      console.error('[saliha-pp] cart error', e);
      showError(root, e.message || 'Errore durante l\'aggiunta al carrello');
    } finally {
      btn.disabled = false;
      btn.removeAttribute('data-loading');
    }
  }

  function initFBT(root, product, state) {
    const checks = Array.from(root.querySelectorAll('[data-saliha-pp-fbt-check]'));
    const totalEl = root.querySelector('[data-saliha-pp-fbt-total]');
    const addBtn = root.querySelector('[data-saliha-pp-fbt-add]');
    if (!checks.length || !addBtn) return;

    const mainEl = root.querySelector('[data-saliha-pp-fbt-main]');
    const mainPrice = mainEl ? parseInt(mainEl.dataset.price || '0', 10) : 0;
    function recompute() {
      let total = mainPrice;
      checks.forEach((c) => {
        if (c.checked) total += parseInt(c.dataset.price || '0', 10);
      });
      if (totalEl) totalEl.textContent = formatMoney(total);
    }
    checks.forEach((c) => c.addEventListener('change', recompute));
    recompute();

    addBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const items = checks.filter((c) => c.checked).map((c) => ({
        id: parseInt(c.dataset.variantId, 10),
        quantity: 1,
      }));
      // Includi sempre il prodotto principale corrente
      const mainV = state && state.currentVariant && state.currentVariant.id;
      if (mainV) {
        items.unshift({ id: mainV, quantity: 1 });
      }
      if (!items.length) return;
      addBtn.disabled = true;
      addBtn.setAttribute('data-loading', 'true');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('Errore aggiunta FBT');
        showToast(root, { title: items.length + ' articoli aggiunti' }, { title: '', price: 0 });
        const cartResp = await fetch('/cart.js').then(r => r.json()).catch(() => null);
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cartResp, sourceId: 'saliha-pp-fbt', data: { source: 'saliha-pp-fbt' } }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') {
          try { drawer.open(); } catch (_) {}
        }
      } catch (err) {
        console.error('[saliha-pp] FBT error', err);
        showError(root, 'Errore durante l\'aggiunta');
      } finally {
        addBtn.disabled = false;
        addBtn.removeAttribute('data-loading');
      }
    });
  }

  function showToast(root, product, variant) {
    const toast = root.querySelector('[data-saliha-pp-toast]');
    if (!toast) return;
    const titleEl = toast.querySelector('[data-saliha-pp-toast-title]');
    const subEl = toast.querySelector('[data-saliha-pp-toast-sub]');
    if (titleEl) titleEl.textContent = product.title;
    const variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title + ' · ' : '';
    if (subEl) subEl.textContent = variantTitle + formatMoney(variant.price);
    toast.classList.add('is-shown');
    clearTimeout(toast.__t);
    toast.__t = setTimeout(() => toast.classList.remove('is-shown'), 2800);
  }

  function showError(root, msg) {
    const err = root.querySelector('[data-saliha-pp-error]');
    if (!err) {
      alert(msg);
      return;
    }
    err.textContent = msg;
    err.hidden = false;
    clearTimeout(err.__t);
    err.__t = setTimeout(() => { err.hidden = true; }, 4000);
  }

  // ──────────────────────────────────────────────────────────
  //   STICKY ATC (solo mobile <750px — gating via CSS)
  //   Visibilità: IntersectionObserver sul CTA principale — appare solo
  //   quando il bottone è uscito dal viewport scrollando verso il basso.
  //   Il bottone sticky delega al CTA principale (.click()): stato
  //   disabled/esaurito e label restano gestiti da syncCTA.
  // ──────────────────────────────────────────────────────────
  function initStickyATC(root, product, state) {
    const sticky = root.querySelector('[data-saliha-pp-sticky]');
    if (!sticky) return;
    const mainCta = root.querySelector('[data-saliha-pp-add-to-cart]');
    const stickyCta = sticky.querySelector('[data-saliha-pp-sticky-cta]');

    if (stickyCta && mainCta) {
      stickyCta.addEventListener('click', (e) => {
        e.preventDefault();
        if (stickyCta.disabled || mainCta.disabled) return;
        mainCta.click();
      });
    }

    function setShown(show) {
      sticky.classList.toggle('is-shown', show);
      // aria-hidden coerente con visibility (CSS): controlli fuori
      // dall'albero a11y quando la barra è nascosta.
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    setShown(false);
    if (!mainCta) return;

    // La barra appare solo quando il CTA è USCITO SOPRA il viewport.
    // Il rect va riletto fresco ad ogni valutazione: l'IntersectionObserver
    // da solo perde le transizioni scavalcate da scroll istantanei/coalizzati.
    function evaluateSticky() {
      const r = mainCta.getBoundingClientRect();
      setShown(r.bottom < 0);
    }
    let stickyRafTick = false;
    function onStickyScroll() {
      if (stickyRafTick) return;
      stickyRafTick = true;
      requestAnimationFrame(() => {
        evaluateSticky();
        stickyRafTick = false;
      });
    }
    window.addEventListener('scroll', onStickyScroll, { passive: true });
    window.addEventListener('resize', onStickyScroll, { passive: true });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(evaluateSticky, { threshold: 0, rootMargin: '0px' });
      io.observe(mainCta);
      root.__stickyIO = io; // riferimento per eventuale cleanup editor
      evaluateSticky();
    } else {
      // Fallback browser datati: soglia px da settings (data-trigger)
      const triggerY = parseInt(sticky.dataset.trigger || '600', 10);
      let stickyTick = false;
      function onScroll() {
        if (stickyTick) return;
        stickyTick = true;
        requestAnimationFrame(() => {
          setShown(window.scrollY > triggerY);
          stickyTick = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  // ──────────────────────────────────────────────────────────
  //   Wishlist + Share
  // ──────────────────────────────────────────────────────────
  function initWishlistShare(root, product) {
    const shareBtn = root.querySelector('[data-saliha-pp-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', async () => {
        const url = window.location.href;
        if (navigator.share) {
          try { await navigator.share({ title: product.title, url }); } catch (_) {}
        } else if (navigator.clipboard) {
          try {
            await navigator.clipboard.writeText(url);
            const orig = shareBtn.getAttribute('aria-label');
            shareBtn.setAttribute('aria-label', 'Link copiato');
            setTimeout(() => shareBtn.setAttribute('aria-label', orig || 'Condividi'), 1500);
          } catch (_) {}
        }
      });
    }
  }

  // ──────────────────────────────────────────────────────────
  //   URGENCY COUNTDOWN — cutoff lun-ven + skip weekend + arrivo +N gg lavorativi
  // ──────────────────────────────────────────────────────────
  function initBonusScarcity(root) {
    var bonuses = root.querySelectorAll('[data-saliha-pp-bonus]');
    if (!bonuses.length) return;
    var nowSec = Math.floor(Date.now() / 1000);
    bonuses.forEach(function (el) {
      var ts = parseInt(el.dataset.deadlineTs || '0', 10);
      if (ts && ts > nowSec) {
        el.removeAttribute('hidden');
      } else {
        el.remove(); // not just hide — remove so screen readers don't announce
      }
    });
  }

  function initGiftForm(root, state) {
    const giftForm = root.querySelector('[data-saliha-pp-giftform]');
    if (!giftForm) return;
    const toggle = giftForm.querySelector('[data-saliha-pp-gift-toggle]');
    const summary = giftForm.querySelector('summary');
    const inpTo = giftForm.querySelector('[data-saliha-pp-gift-to]');
    const inpFrom = giftForm.querySelector('[data-saliha-pp-gift-from]');
    const inpMsg = giftForm.querySelector('[data-saliha-pp-gift-msg]');
    const counter = giftForm.querySelector('[data-saliha-pp-gift-counter]');
    const preview = giftForm.querySelector('[data-saliha-pp-gift-preview]');
    const prevTo = giftForm.querySelector('[data-saliha-pp-gift-prev-to]');
    const prevFrom = giftForm.querySelector('[data-saliha-pp-gift-prev-from]');
    const prevMsg = giftForm.querySelector('[data-saliha-pp-gift-prev-msg]');

    // Telemetry — fire once per (session, variant) when user expands the gift form.
    // Bug #3 fix: reset on variant change so subsequent box openings are tracked.
    let giftOpenTracked = false;
    function fireGiftOpened() {
      if (giftOpenTracked) return;
      giftOpenTracked = true;
      try {
        (window.dataLayer = window.dataLayer || []).push({
          event: 'gift_form_opened',
          gift_block_id: giftForm.id || 'gift_form',
          variant_id: state && state.currentVariant ? state.currentVariant.id : null,
        });
        document.dispatchEvent(new CustomEvent('saliha:gift:opened', { detail: { source: 'pdp' } }));
      } catch (_) {}
    }
    root.addEventListener('saliha:variant:changed', function() {
      giftOpenTracked = false;
    });

    // Sync <details> open state with the visual checkbox AND aria-expanded.
    if (summary && toggle) {
      giftForm.addEventListener('toggle', () => {
        const open = giftForm.open;
        toggle.checked = open;
        summary.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          fireGiftOpened();
          syncPreview(); // show seductive default on open
        }
      });
      toggle.addEventListener('change', () => {
        giftForm.open = toggle.checked;
      });
    }

    function syncCounter() {
      if (!counter || !inpMsg) return;
      counter.textContent = String(inpMsg.value.length);
    }

    // F5 · Default self-gift preview (Le Labo "For: You" tactic)
    // Quando il form è espanso ma vuoto, mostriamo un default self-gift invitante
    // invece di nascondere l'anteprima — converte indecisi su "per me stessa".
    const SELF_GIFT_DEFAULT = {
      to: 'Per te',
      msg: 'Un primo passo che meriti. Bismillah · in pace.',
      from: ''
    };
    function syncPreview() {
      if (!preview) return;
      const valTo = inpTo ? inpTo.value.trim() : '';
      const valFrom = inpFrom ? inpFrom.value.trim() : '';
      const valMsg = inpMsg ? inpMsg.value.trim() : '';
      const hasAny = valTo || valFrom || valMsg;
      const isFormOpen = giftForm.open;
      if (hasAny) {
        preview.hidden = false;
        preview.dataset.mode = 'user';
        if (prevTo) prevTo.textContent = valTo ? 'Per ' + valTo : '';
        if (prevFrom) prevFrom.textContent = valFrom ? 'Da ' + valFrom : '';
        if (prevMsg) prevMsg.textContent = valMsg;
      } else if (isFormOpen) {
        // Show seductive default to nudge action (even if user buys for self)
        preview.hidden = false;
        preview.dataset.mode = 'default';
        if (prevTo) prevTo.textContent = SELF_GIFT_DEFAULT.to;
        if (prevFrom) prevFrom.textContent = SELF_GIFT_DEFAULT.from;
        if (prevMsg) prevMsg.textContent = SELF_GIFT_DEFAULT.msg;
      } else {
        preview.hidden = true;
      }
    }

    [inpTo, inpFrom, inpMsg].forEach((el) => {
      if (!el) return;
      el.addEventListener('input', () => {
        syncPreview();
        if (el === inpMsg) syncCounter();
      });
    });
    syncCounter();

    // Date picker · min today+5, max +90gg
    // M1 fix: parse <input type=date> value as LOCAL midnight (not UTC) to avoid
    // off-by-1-day in Italian timezone. new Date('2026-07-01') = UTC midnight = previous day in IT.
    const inpDate = giftForm.querySelector('[data-saliha-pp-gift-date]');
    const dateHint = giftForm.querySelector('[data-saliha-pp-gift-date-hint]');
    if (inpDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const minDate = new Date(today); minDate.setDate(minDate.getDate() + 5);
      const maxDate = new Date(today); maxDate.setDate(maxDate.getDate() + 90);
      const fmtLocal = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return y + '-' + m + '-' + day;
      };
      inpDate.setAttribute('min', fmtLocal(minDate));
      inpDate.setAttribute('max', fmtLocal(maxDate));
      inpDate.addEventListener('change', () => {
        if (!dateHint) return;
        if (!inpDate.value) { dateHint.textContent = ''; return; }
        // Parse YYYY-MM-DD as local time (not UTC)
        const parts = inpDate.value.split('-').map(Number);
        if (parts.length !== 3) return;
        const sel = new Date(parts[0], parts[1] - 1, parts[2]);
        const days = Math.round((sel - today) / 86400000);
        if (days < 5) {
          dateHint.textContent = '⚠ Tempi stretti — ti contattiamo per confermare la fattibilità.';
          dateHint.dataset.state = 'warn';
        } else if (days < 8) {
          dateHint.textContent = '✓ Fattibile · spediremo express.';
          dateHint.dataset.state = 'ok';
        } else {
          dateHint.textContent = '✓ Tempistica comoda · prepareremo con cura.';
          dateHint.dataset.state = 'ok';
        }
      });
    }

    // Wrap upgrade telemetry
    const wraps = giftForm.querySelectorAll('[data-saliha-pp-gift-wrap]');
    wraps.forEach((w) => {
      w.addEventListener('change', () => {
        if (w.checked && w.value === 'velvet') {
          try {
            (window.dataLayer = window.dataLayer || []).push({
              event: 'gift_wrap_upgrade_selected',
              wrap_type: 'velvet',
              upcharge_eur: 8,
            });
          } catch (_) {}
        }
      });
    });
  }

  function initSoldoutWaitlist(root, product) {
    const form = root.querySelector('[data-saliha-pp-soldout-form]');
    if (!form) return;
    const success = root.querySelector('[data-saliha-pp-soldout-success]');
    const errorEl = root.querySelector('[data-saliha-pp-soldout-error]');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      if (errorEl) errorEl.setAttribute('hidden', '');
      // Successo mostrato solo se il POST va a buon fine: il lead non
      // deve credersi iscritto quando la richiesta è fallita.
      try {
        const res = await fetch('/contact', { method: 'POST', body: fd });
        if (!res.ok) throw new Error('contact ' + res.status);
      } catch (_) {
        if (errorEl) errorEl.removeAttribute('hidden');
        return;
      }
      try {
        document.dispatchEvent(new CustomEvent('saliha:waitlist:joined', {
          detail: {
            handle: product.handle,
            product_id: product.id,
            email: fd.get('contact[email]'),
            source: 'pdp_soldout',
          },
        }));
        (window.dataLayer = window.dataLayer || []).push({
          event: 'waitlist_join',
          source: 'pdp_soldout',
          product_handle: product.handle,
          product_id: product.id,
        });
      } catch (_) {}
      if (success) {
        form.style.display = 'none';
        success.removeAttribute('hidden');
      }
    });
  }

  function initUrgencyCountdown(root) {
    const el = root.querySelector('[data-saliha-pp-urgency]');
    if (!el) return;
    // Override manuale: se urgency_text settato in Theme Editor, non scrivere
    const textNode = el.querySelector('[data-saliha-pp-urgency-text]');
    if (!textNode) return;

    const cutoffH = parseInt(el.dataset.cutoffHour || '14', 10);
    const cutoffM = parseInt(el.dataset.cutoffMinute || '0', 10);
    const deliveryDays = parseInt(el.dataset.deliveryDays || '2', 10);

    const MONTHS = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
    const DAYS_FULL = ['Domenica','Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato'];
    const DAYS_SHORT = ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'];

    function addBusinessDays(date, n) {
      const d = new Date(date);
      let added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return d;
    }
    function fmtArrival(date) {
      return `${DAYS_SHORT[date.getDay()]} ${date.getDate()} ${MONTHS[date.getMonth()]}`;
    }
    function pad(n) { return String(n).padStart(2, '0'); }

    function render() {
      const now = new Date();
      const dow = now.getDay(); // 0=Dom, 6=Sab
      const isWeekend = (dow === 0 || dow === 6);
      const cutoff = new Date(now);
      cutoff.setHours(cutoffH, cutoffM, 0, 0);

      let html = '';
      if (isWeekend) {
        // weekend: prossimo giorno utile = lunedì
        const nextWorkday = new Date(now);
        do { nextWorkday.setDate(nextWorkday.getDate() + 1); } while (nextWorkday.getDay() === 0 || nextWorkday.getDay() === 6);
        const arrival = addBusinessDays(nextWorkday, deliveryDays - 1);
        html = `Spedito ${DAYS_FULL[nextWorkday.getDay()]} · arrivo ${fmtArrival(arrival)}`;
      } else if (now < cutoff) {
        // dentro la finestra di oggi
        const diff = cutoff - now;
        const hh = Math.floor(diff / 3600000);
        const mm = Math.floor((diff % 3600000) / 60000);
        const ss = Math.floor((diff % 60000) / 1000);
        const arrival = addBusinessDays(now, deliveryDays);
        let timeStr;
        if (hh > 0) timeStr = `${hh}h ${pad(mm)}m`;
        else timeStr = `${mm}m ${pad(ss)}s`;
        html = `Ordina entro <strong>${timeStr}</strong> · spedito oggi · arrivo <strong>${fmtArrival(arrival)}</strong>`;
      } else {
        // dopo cutoff oggi: spedizione domani (se non venerdì) o lunedì (venerdì dopo cutoff)
        let nextShipDay = new Date(now);
        do { nextShipDay.setDate(nextShipDay.getDate() + 1); } while (nextShipDay.getDay() === 0 || nextShipDay.getDay() === 6);
        const arrival = addBusinessDays(nextShipDay, deliveryDays - 1);
        html = `Spedito ${DAYS_FULL[nextShipDay.getDay()]} · arrivo ${fmtArrival(arrival)}`;
      }
      textNode.innerHTML = html;
    }

    render();
    // Tick ogni secondo quando dentro la finestra giornaliera, ogni minuto altrimenti
    const tick = setInterval(render, 1000);
    // Cleanup se sezione viene rimossa
    root.__urgencyTick = tick;
  }

  // ──────────────────────────────────────────────────────────
  //   Money formatter (uses Shopify.formatMoney if available)
  // ──────────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '€{{amount}}');
    }
    const v = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + v;
  }

  // ──────────────────────────────────────────────────────────
  //   Boot
  // ──────────────────────────────────────────────────────────
  function boot() {
    document.querySelectorAll('[data-saliha-pp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on theme editor section load
  document.addEventListener('shopify:section:load', (e) => {
    if (!e.target) return;
    e.target.querySelectorAll('[data-saliha-pp]').forEach(init);
  });
})();
